// 許可するURLスキーム（sanitize-htmlライブラリのデフォルト設定と同様）
const ALLOWED_PROTOCOLS = ['http:', 'https:', 'mailto:']

/**
 * URLをサニタイズして、許可されたスキームのみを返す
 * javascript:, data:, vbscript: などの危険なスキームを防ぐ
 *
 * @param {string} rawUrl - サニタイズするURL
 * @returns {string|null} - 許可されたURLまたはnull
 */
export function sanitizeUrl(rawUrl) {
  if (!rawUrl) return null

  const trimmed = rawUrl.trim()
  if (!trimmed) return null

  try {
    // URLをパースして、スキームを検証
    const parsed = new URL(trimmed)

    // 許可されたスキームのみを通す
    if (!ALLOWED_PROTOCOLS.includes(parsed.protocol)) {
      return null
    }

    return trimmed
  } catch {
    // URLとしてパースできない場合は無効
    return null
  }
}

export default {
  sanitizeUrl
}
